$(document).ready(function(){
    $('#apply').form({
        on: 'blur',
         inline : true, 
        fields: {
            name: {
                identifier: 'name',
                rules: [{
                    type: 'empty',
                    prompt: 'Please enter your name'
                }]
            },
            email: {
                identifier: 'email',
                rules: [{
                    type: 'empty',
                    prompt: 'Please enter your Email'
                }]
            },
            upload: {
                identifier: 'upload',
                rules: [{
                    type: 'empty',
                    prompt: 'Please upload your Resume'
                }]
            },
            
        }
    });
});
